var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.959 3.14263L19.334 20.1641C19.293 20.5743 19.0469 20.9434 18.6778 21.1485C18.4727 21.2305 18.2676 21.3126 18.0215 21.3126C17.8575 21.3126 17.6934 21.2715 17.5293 21.1895L12.5254 19.0977L10.4336 22.2149C10.2696 22.502 9.98245 22.6251 9.69534 22.6251C9.24417 22.6251 8.87503 22.2559 8.87503 21.8047V17.8672C8.87503 17.5391 8.95706 17.252 9.12112 17.0469L18.0625 5.56255L6.00394 16.4317L1.77933 14.668C1.32816 14.4629 1.00003 14.0528 1.00003 13.5196C0.959015 12.9454 1.20511 12.5352 1.65628 12.2891L20.0313 1.83013C20.4414 1.58404 21.0157 1.58404 21.4258 1.87115C21.836 2.15826 22.041 2.65044 21.959 3.14263Z",
    fill: "#13C1BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5488 0.830019C23.2617 0.624941 22.8515 0.583925 22.5234 0.789004L3.49214 11.6171C3.16401 11.7812 2.95894 12.1503 2.99995 12.5195C2.99995 12.8886 3.24605 13.2167 3.57417 13.3808L9.89058 16.0058V20.6406C9.89058 21.0097 10.0546 21.3378 10.3828 21.5429C10.5468 21.5839 10.7109 21.6249 10.8339 21.6249C10.998 21.6249 11.2031 21.5839 11.3671 21.5019L15.9199 18.5488L19.9394 20.2714C20.0625 20.3124 20.1855 20.3535 20.3496 20.3535C20.5136 20.3535 20.6777 20.2714 20.8007 20.1894C21.0878 20.0663 21.2519 19.7792 21.2929 19.4921L23.9179 1.77338C24.041 1.40424 23.8769 1.0351 23.5488 0.830019ZM18.1347 5.54682L10.4648 14.1191L6.19917 12.3144L18.1347 5.54682ZM11.8183 18.8359V16.8261L13.705 17.6464L11.8183 18.8359ZM19.5703 17.9335L12.3515 14.8984L21.539 4.68549L19.5703 17.9335Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPaperPlane);
export default __webpack_public_path__ + "static/media/img_paperPlane.ab331b4baecc5360344f50f7feebfe02.svg";
export { ForwardRef as ReactComponent };